import { omitBy } from "lodash";

interface IColumn {
  content: string;
  colspan: number;
  rowspan: number;
  display: boolean;
  bgColor: string;
  textAlign: any; // string
  isHeader: boolean;
}

interface IColumnGroup {
  span: number;
  width: string;
}

interface IProps {
  data?: {
    rows: Array<Array<IColumn>>;
    colgroup: IColumnGroup[];
  };
  className?: string;
}

function ComplexTableRenderer({ data, className }: IProps) {
  try {
    if (!data) {
      return <></>;
    }

    const { rows, colgroup } = data;

    return (
      <div className="widget cdx-table">
        <table>
          <tbody>
            {rows.map((columns, rowKey) => {
              return (
                <tr key={rowKey}>
                  {columns.map((column, columnKey) => {
                    const { colspan, rowspan, bgColor, textAlign, display } =
                      column;

                    const style = {
                      backgroundColor: bgColor,
                      textAlign,
                      display: display === false ? "none" : "",
                    };

                    return (
                      <td
                        key={columnKey}
                        colSpan={colspan}
                        rowSpan={rowspan}
                        style={omitBy(style, (v) => v === "")}
                      >
                        {column.content}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет ComplexTable: ${error}`);
    return <></>;
  }
}

export default ComplexTableRenderer;
